<template>
    <el-card shadow="never">
        <div class="header">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
            <el-breadcrumb-item>用户列表</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
    </el-card>
    <el-card shadow="never" style="margin-top:20px">
        <el-table row-key="id" v-loading="baseData.loading" border :data="tableData.data" style="width: 100%;margin-top: 10px;">
          <el-table-column prop="id" label="ID" width="60"/>
          <el-table-column prop="nickname" label="昵称"/>
          <el-table-column label="头像" width="130">
            <template #default="scope">
              <img v-if="scope.row.avatar" :src="scope.row.avatar" style="width: 100px;height: 100px;border-radius: 10px;" />
            </template>
          </el-table-column>
          <el-table-column prop="ip" label="登录IP" width="100"/>
          <el-table-column prop="login_time" label="登录时间" width="160"/>
          <el-table-column prop="created_at" label="创建时间" width="160"/>
          <el-table-column label="状态" width="100">
            <template #default="scope">
              <el-text v-if="scope.row.status == 1" type="success">正常</el-text>
              <el-text v-else type="danger">冻结</el-text>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="200" >
            <template #default="scope">
              <el-button size="small" @click="showInCode(scope.row.id)" type="primary">获取邀请码</el-button>
              <el-popconfirm
                v-if="scope.row.status == 1"
                confirm-button-text="是"
                cancel-button-text="否"
                title="确定设置冻结吗?"
                @confirm="changeStatus(scope.row.id,0)"
              >
                <template #reference>
                  <el-button  size="small" type="danger">设置冻结</el-button>
                </template>
              </el-popconfirm>
              <el-button v-else size="small" @click="changeStatus(scope.row.id,1)" type="success">设置正常</el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagestyle">
          <el-pagination
            v-model:current-page="searchForm.page"
            v-model:page-size="searchForm.limit"
            layout="sizes, prev, pager, next"
            :total="tableData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
    </el-card>

    <el-dialog v-model="baseData.userbox" title="邀请码">
      <el-form :model="formData" label-width="120">
        <el-form-item label="邀请码">
          <img v-if="formData.inimg" :src="'https://img.go.996w.cn/' + formData.inimg" class="avatar" />
        </el-form-item>
        <el-form-item label="充值模式">
          <el-input v-model="formData.modeltype" autocomplete="off" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="createIncode">生成邀请码</el-button>
          <el-button @click="baseData.userbox = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  const searchForm = reactive({
    limit:10,
    page:1,
  })
  const baseData = reactive({
    loading:false,
    title:'',
    userbox:false,
  })
  const formData:any = reactive({
    modeltype:0,
    inimg:"",
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const showInCode = (id:number) => {
    baseData.userbox = true
    formData.id = id
    formData.modeltype = 0
    formData.inimg = ""
  }
  const createIncode = () => {
    const loading = ElLoading.service({
      lock: true,
    })
    api.memberApi.createIncode({id:formData.id,modeltype:formData.modeltype}).then((res:any)=>{
      loading.close()
      if(res.code==200){
        formData.inimg = res.data.img
        ElMessage({
          message: res.message,
          type: 'success',
        })
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getList = () => {
    baseData.loading = true
    api.memberApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        tableData.data = res.data.list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const changeStatus = (id:number,status:number) => {
    baseData.loading = true
    api.memberApi.changeStatus({id:id,status:status}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const del = (id:number) => {
    baseData.loading = true
    api.memberApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  onMounted(() => {
    getList()
  })
  </script>